// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"1cd8b78f","703":"d22907c6"}[chunkId] + ".chunk.js";
};